import React, { useState, useEffect } from "react";
import moment from "moment";
import * as style from "./styles.module.scss";
import Pagination from "./Pagination";

const HolidayHistory = ({ holidayHistoryData }) => {
  const [holidayHistory, setHolidayHistory] = useState(holidayHistoryData);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
  };

  useEffect(() => {
    setHolidayHistory(holidayHistoryData);
  }, [holidayHistoryData]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const displayHolidayStatus = (status) => {
    return status === "rejected" ? "Declined" : status;
  };

  const getStatusClassName = (status) => {
    switch (status) {
      case "approved":
        return "bg-success";
      case "rejected":
        return "bg-danger";
      default:
        return "bg-warning";
    }
  };

  const firstIndex = Math.min(
    (currentPage - 1) * itemsPerPage,
    holidayHistory.length
  );
  const lastIndex = Math.min(currentPage * itemsPerPage, holidayHistory.length);
  const currentItems = holidayHistory.slice(firstIndex, lastIndex);

  const displayEndDate = (startDate, endDate) =>
    endDate && endDate !== startDate
      ? ` - ${moment(endDate).format("DD/MM/YYYY")}`
      : "";

  const noticeText =
    "Only holiday requested from 26/05/23 will be shown here.\n" +
    "For any holiday requested before this date, please ensure you wait for approval from your HRGO consultant.";

  return (
    <div className="container mb-1">
      <div className="row">
        <div className={style.cardStylesHoliday}>
          <div className={style.formBackground}>
            <div className={style.tableWrapper}>
              {holidayHistory.length > 0 ? (
                <>
                  <table className={`table ${style.tableHr} holiday_table`}>
                    <thead className={style.tableHead}>
                      <tr>
                        <th
                          scope="col"
                          className={`${style.tableHeadCell} ${style.tableHeadCellDate}`}
                        >
                          Date
                        </th>
                        <th
                          scope="col"
                          className={`${style.tableHeadCell} ${style.tableHeadCellNotes}`}
                        >
                          Candidate comments
                        </th>
                        <th
                          scope="col"
                          className={`${style.tableHeadCell} ${style.tableHeadCellComments}`}
                        >
                          Approver comments
                        </th>
                        <th
                          scope="col"
                          className={`${style.tableHeadCell} ${style.tableHeadCellStatus}`}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((holiday, index) => {
                        return (
                          <tr key={index} className={style.tableRow}>
                            <td>
                              {moment(holiday.date).format("DD/MM/YYYY")}
                              {displayEndDate(holiday.date, holiday.end_date)}
                            </td>
                            <td>{holiday.notes}</td>
                            <td>{holiday.user_comments}</td>
                            <td className={style.tableRowCellStatus}>
                              <span
                                className={`rounded-pill text-white small ${
                                  style.statusText
                                } ${getStatusClassName(holiday.status)}`}
                              >
                                {displayHolidayStatus(holiday.status)}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <p className={`mb-0 pt-0 ${style.textNotice}`}>
                    {noticeText}
                  </p>
                  <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={holidayHistory.length}
                    onPageChange={handlePageChange}
                    currentPage={currentPage}
                    onItemsPerPageChange={handleItemsPerPageChange}
                  />
                </>
              ) : (
                <div className={style.notFoundContainer}>
                  <div className="text-center mt-1">
                    <p className="font-weight-bold">
                      No holiday history found.
                    </p>
                    <p className={style.textNotice}>{noticeText}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayHistory;
